export default __webpack_public_path__ + "static/media/frame-2.488cde96.png";